import { Author } from 'types/Slideshow';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { colors, screen } from 'components/styles/variables';

interface TitleProps {
  title: string;
  author: Author;
  date: Date;
}

function TitleComponent({ title, author, date }: TitleProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="title-component">
      <div className="slide-title">{title}</div>
      <div className="slide-byline">
        <span>{`${t(`article.by`)} `}</span>
        <span>
          <Link href={`/news-and-analysis${author.bylineurl}`} legacyBehavior>
            <a className="author-link">{author.name}</a>
          </Link>
        </span>
        <span>
          {` | ${date.toLocaleString(undefined, {
            month: 'long',
          })} ${date.getUTCDate()}, ${date.getUTCFullYear()}`}
        </span>
      </div>
      <style jsx>{`
        .title-component {
          width: 100%;
          padding: 0 32px;
          margin: 16px 0;
        }

        .slide-title {
          color: ${colors.BLACK};
          font-size: 28px;
          font-weight: 600;
          line-height: 1.25;
          letter-spacing: 0.2px;
        }

        .slide-byline {
          line-height: 1.4;
          color: ${colors.BLACK};
          font-size: 16px;
          margin: 8px 0px;
        }

        .author-link {
          color: ${colors.ALR1};
          font-weight: 100;
        }

        .author-link:hover {
          color: ${colors.ALR1};
          text-decoration: underline;
        }

        @media (min-width: ${screen.smMin}) {
          .title-component {
            width: 728px;
            padding: 0;
          }
        }

        @media (min-width: ${screen.lgMin}) {
          .title-component {
            width: 1044px;
            padding: 0;
          }
        }
      `}</style>
    </div>
  );
}

export default TitleComponent;
